//= require jquery
import "jquery"; // jQuery (1.11.3)

// require rails-ujs
import Rails from "@rails/ujs";

// require jquery-validation/dist/jquery.validate
import "@vendor/bower_components/jquery-validation/dist/jquery.validate";

// require parsleyjs/dist/parsley
import "@vendor/bower_components/parsleyjs/dist/parsley";

Rails.start();
